import { Switch } from '@material-ui/core';
import { withStyles } from '@material-ui/core/styles';

export const CustomSwitch = withStyles((theme) => ({
  root: {
    width: 40,
    height: 24,
    padding: 1,
    display: 'flex',
  },
  switchBase: {
    width: 'initial !important',
    padding: 2,
    color: '#b0b0b0',
    '&$checked': {
      transform: 'translateX(16px)',
      color: theme.palette.common.white,
      '& + $track': {
        opacity: 1,
        backgroundColor: theme.palette.secondary.main,
        borderColor: theme.palette.secondary.main,
      },
    },
  },
  thumb: {
    width: 20,
    height: 20,
    boxShadow: 'none',
  },
  track: {
    border: `1px solid ${theme.palette.grey[500]}`,
    borderRadius: 20 / 2,
    opacity: 1,
    backgroundColor: '#b0b0b0',
  },
  checked: {},
}))(Switch);
